export let answerMixinBlock = {
	initAnswer: (self, CLS) => {
		let initCheckbox = () => {
			let $formCheckbox = self.$element.find(`.${CLS}-formCheckbox`);

			self.$element.on('click', () => {
				if(!$formCheckbox.prop('readonly') && !$formCheckbox.prop('disabled')) {
					$formCheckbox.prop('checked', !$formCheckbox.prop('checked'));
					$formCheckbox.trigger('change');
				}
			});

			$formCheckbox.on('click', (event) => {
				event.stopPropagation();
			});

			let checkboxName = $formCheckbox.attr('name');
			if(checkboxName) {
				$formCheckbox.on('change', () => {
					if($formCheckbox.prop('checked')) {
						self.$element.addClass(`${CLS}--selected`);
					}
					else {
						self.$element.removeClass(`${CLS}--selected`);
					}
				});
			}

			let checked = $formCheckbox.attr('checked');
			if(checked) {
				$formCheckbox.prop('checked', true);
				$formCheckbox.trigger('change');
			}
		};

		let initRadio = () => {
			let $formRadio = self.$element.find(`.${CLS}-formRadio`);

			self.$element.on('click', () => {
				if(!$formRadio.prop('readonly') && !$formRadio.prop('disabled') && !$formRadio.prop('checked')) {
					$formRadio.prop('checked', true);
					$formRadio.trigger('change');
				}
			});

			$formRadio.on('click', (event) => {
				event.stopPropagation();
			});

			let radioName = $formRadio.attr('name');
			if(radioName) {
				$(`input:radio[name=${radioName}]`).on('change', () => {
					if($formRadio.prop('checked')) {
						self.$element.addClass(`${CLS}--selected`);
					}
					else {
						self.$element.removeClass(`${CLS}--selected`);
					}
				});
			}

			let checked = $formRadio.attr('checked');
			if(checked) {
				$formRadio.prop('checked', true);
				$formRadio.trigger('change');
			}
		};

		let initDisabledToggleEvent = () => {
			if(self.$element.find('input').prop('disabled')) {
				self.$element.addClass(`${CLS}--disabled`);
			}

			let observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if(mutation.attributeName === 'disabled') {
						if(self.$element.find('input').prop('disabled')) {
							self.$element.addClass(`${CLS}--disabled`);
						}
						else {
							self.$element.removeClass(`${CLS}--disabled`);
						}
					}
				});
			});

			let config = { attributes: true };
			observer.observe(self.$element.find('input')[0], config);

			window.addEventListener('unload', () => {
				observer.disconnect();
			});
		};

		// Checkbox
		if(!_.isNil(self.$element.data('multiple')) && self.$element.data('multiple')) {
			initCheckbox();
		}
		// Radio
		else {
			initRadio();
		}

		// Listen to disabled attribute
		initDisabledToggleEvent();
	}
};
